var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    attrs: {
      "className": "header--light"
    }
  }, [_c('sub-visual', {
    attrs: {
      "sh": "위치안내",
      "tabActive": "위치안내",
      "bg": "/images/sub/visual/sv5.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "border pa-20 pa-md-30 pa-lg-50 mb-50 mb-lg-100 cap-wrap"
  }, [_c('div', {
    staticClass: "w-100",
    attrs: {
      "data-aos": "zoom-in-up"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/location/map.png",
      "max-width": "580",
      "contain": ""
    }
  })], 1)]), _c('v-row', {
    staticClass: "ma-xl-n30"
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('v-col', {
      key: index,
      staticClass: "pa-xl-30",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('location', {
      attrs: {
        "tit": item.tit,
        "address": item.address,
        "tel": item.tel,
        "mapImage": item.mapImage,
        "link": item.link
      }
    })], 1)];
  })], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }